import React from 'preact/compat';

import translator from 'Flyout/Api/Translator';
import SingleResult from './SingleResult';

export default function SearchResults(props) {
    const {
        results, numRes, text,
    } = props;

    const content = (results.length > 0) ? (
        <>
            <div className="results-info">
                { `${numRes} ${translator.i18n('results for')} "${text}":`}
            </div>
            <ul>
                { results.map((result) => (
                    <SingleResult url={result.url} title={result.title} treePath={result.treePath} />
                ))}
            </ul>
        </>
    ) : (
        <div className="results-info">
            <div>
                {translator.i18n('There were no results matching your search within TUD\'s organizational units.')}
            </div>
            <div>
                {`${translator.i18n('Try using the')} `}
                <a href={`${window.PORTAL_URL}/@@search?SearchableText=${text}`}>
                    <strong>
                        {translator.i18n("full-text search on the website")}
                    </strong>
                </a>
                {`${translator.i18n(' to find what you are looking for.')} `}
            </div>
        </div>
    );

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            { content }
        </>
    );
}
